import React from "react";
import { useSelector } from "react-redux";
import Language from "../components/vendors/Language";
import CmsSlider from "../pages/vendors/CmsSlider";
import { RootState } from "../store/store";

const AuthLayout: React.FC = ({ children }: any) => {


    const tenantLogo = useSelector((state: RootState) => state.global.tenantLogo);

    return (

        <div className="flex items-center  justify-center md:w-screen md:h-screen bg-gray-50 dark:bg-gray-900 ">
            <div className="w-full   md:w-7/12   mx-auto  bg-white md:rounded-3xl shadow-xl dark:bg-gray-800">
                <div className="flex flex-col lg:flex-row h-full">
                    {/* mobile nav */}
                    <div className="flex justify-between items-center px-4 h-24  lg:hidden mb-2 rounded-br-3xl rounded-bl-3xl shadow-xl">
                        <img
                            className="w-2/10 h-1/2  object-contain"
                            src={tenantLogo || "/logo.png"}
                        />
                        <Language />
                    </div>
                    {/* mobile img */}
                    <div className="lg:hidden">

                        <img className=" w-full h-64 " src="/asset/pic1.jpeg"></img>
                    </div>


                    <CmsSlider />



                    <main className="flex flex-col lg:w-1/2 ">
                        <div className="lg:flex mt-6 lg:flex-row-reverse hidden w-3/4 mx-auto ">
                            <Language />
                        </div>
                        <div className="flex items-center justify-center pb-20 pt-10">
                            {children}
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
}
export default AuthLayout;
